(function () {
    'use strict';

    angular.module('swif.ui')
    .config(route)
    .directive('bodyBackground', bodyBackground);


    function route($routeProvider) {
        'ngInject';
        $routeProvider.when('/login', {
            templateUrl: 'partials/ui/login.html',
            controller: LoginController,
            resolve: {
                data: ['swifRouteService', function (route) {
                    return route.check({public: true});
                }]
            }
        });
    }


    function LoginController(
        $rootScope, $scope, $location, swif, settingsService, msgService, actionService, userService, swifOAuthService,
        swifOpenbaseLanguageService, Idle) {
        'ngInject';
        var settings = settingsService;
        console.log('LoginController');
        //settings.reset();

        $scope.loading = {login: {}};
        $scope.user = {
            login: '',
            password: ''
        };
        $scope.user.db = settings.app.db;
        $scope.mobileApplication = settings.app.mobileApplication;
        $scope.passwordType = 'password';

        var userActions = actionService.getActions('user', 'user');
        for (var i = 0; i < userActions.length; i++) {
            if (userActions[i].id === 'login') {
                $scope.loginAction = userActions[i];
            }
        }
        if (!$scope.loginAction && $location.path() === '/login') {
            userService.redirectAfterLogin();
        }

        $scope.hidePassword = hidePassword;
        $scope.showPassword = showPassword;
        $scope.login = login;
        $scope.loginCallback = loginCallback;
        $scope.oauth = swifOAuthService.oauth;
        if (settings.app.modules.opengst_oauth) {
            swifOAuthService.dispatchLogin($scope.loginCallback);
        }

        var init = function() {
            var http = {
                url: '/web/user/getcompany',
                params: {
                    db: settings.app.db,
                    fields: ['display_signup_link', 'is_canadian']
                }
            }
            swif.data.post(undefined, http, false).then((company) => {
                $scope.displayLinkSignupCitizen = company.display_signup_link;
                $scope.isCanadian = company.is_canadian;
            });
        }
        init();

        function hidePassword() {
            $scope.passwordType = 'password';
        }


        function showPassword() {
            $scope.passwordType = 'text';
        }


        function login() {
            if (_.isEmpty($scope.user.login) || _.isEmpty($scope.user.password)) {
                return;
            }
            msgService.loading($scope.loading.login);
            actionService.dispatch(
                'user',
                $scope.loginAction,
                $scope.user,
                {callback: $scope.loginCallback}
            );
        }
        function loginCallback(error, data) {
            if (error) {
                msgService.loading($scope.loading.login, 'ko');
                msgService.addError(error);
                $scope.loginError = error;
            } else {
                if (data.action.id === 'login' || data.action.id === 'oauth_login') {
                    msgService.loading($scope.loading.login, 'ok');
                    if (data.result.uid === false) {
                        $scope.badloginorpassword = true;
                        msgService.addInfo('Bad login or password');
                        return;
                    }
                    $scope.badloginorpassword = false;
                    userService.setAuthenticatedUser(data)
                    .then(function (data) {
                        swifOpenbaseLanguageService.applyLang(data.user.context.lang);

                        userService.redirectAfterLogin();
                        msgService.addInfo('Login success');
                        $rootScope.$emit('authenticationEvent');
                        setTimeout(function () {
                            $('.navbar-logo').show();
                        }, 100);

                        if(swif.settings.app.features.timeoutDuration){
                            Idle.watch()
                        }
                    }, function (error) {
                        msgService.addError(error);
                    });
                }
            }
        }


    }




    /**
    * @ngdoc directive
    * @name swif.ui:bodyBackground
    * @module swif.ui
    * @restrict A
    * @description display background image from the settings
    **/
    function bodyBackground(settings) {
        'ngInject';
        return {
            restrict: 'A',
            link: function (scope) {
                var medias = settings.app.medias || settings.app.defaultValues.medias;
                if (medias) {
                    if (medias.cityWallpaper) {
                        var bg = 'background-image: url(\'' + medias.cityWallpaper + '\')';
                        $('body').attr('style', bg).addClass('city-wallpaper');
                    }
                }
                $('#footer-navbar').addClass('navbar-fixed-bottom');
                scope.$on('$destroy', function () {
                    $('body').attr('style', '').removeClass('city-wallpaper');
                    $('#footer-navbar').removeClass('navbar-fixed-bottom');
                });
            }
        };
    }



})();
